import React, { useCallback, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import { SelectorOptions } from 'shared/design-system/components/Selector';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

const StyledDiv = styled.div`
  .question-text {
    margin-bottom: ${SPACERS.medium};
  }
`;

const defaultGetLabel = (value: string) => value;

const Allocation = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(({ reportId, questionId, question, answer }, forwardRef) => {
  const [value, setValue] = useState<string>(answer);

  useImperativeHandle(forwardRef, () => ({
    reportId,
    questionId,
    answer: () => value,
    errorText: () => (!value ? 'Please select one of the options.' : ''),
  }));

  const options = question.enumResponses
    .filter(({ response }) => response !== 'To create a new program')
    .map(({ response }) => response);

  const handleChange = useCallback(
    (value: string) => {
      setValue(value);
    },
    [setValue],
  );

  return (
    <StyledDiv>
      <TrueImpactText variant="heading" className="question-text">
        {question.text}
      </TrueImpactText>
      <SelectorOptions
        variant="radio"
        options={options}
        padding={SPACERS.small}
        onClick={handleChange}
        getLabel={defaultGetLabel}
        getSelected={val =>
          value.replace(/['’]/g, '') === val.replace(/['’]/g, '')
        }
      />
    </StyledDiv>
  );
});

export default Allocation;
